import React from 'react';
import { useTranslation } from 'react-i18next';

const Terms = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen mt-[78px] px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1280px] mx-auto pt-[92px] pb-[100px] break-words whitespace-normal">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-[48px] leading-[53px] font-normal libre-baskerville text-black">
            {t('terms.title')}
          </h1>
        </div>

        {/* Introduction */}
        <div className="mb-10 space-y-4">
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.intro')}
          </p>
        </div>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.acceptance')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.acceptance')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.changes')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.changes')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.products')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.products')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.pricing')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.pricing')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.order')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.order')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.shipping')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.shipping')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.returns')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.returns')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.account')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.account')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.ip')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('terms.content.ip')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.prohibited')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.prohibited.intro')}
          </p>
          <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium ml-6">
            {(
              t('terms.content.prohibited.items', { returnObjects: true }) || []
            ).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.disclaimer')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.disclaimer')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.liability')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.liability')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.indemnification')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.indemnification')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.law')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.law')}
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('terms.sections.contact')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.contact.intro')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.contact.email')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.contact.phone')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('terms.content.contact.address')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
